import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import routes from '../consts/routes';
import {setIsNetworkNotificationsDisabled} from '../state/slice/global';
import {dispatch} from '../state/store';

const DISABLED_NETWORK_NOTIFICATIONS_PAGES = [
    routes.WIFI_CONNECTION_GUIDE_INTRO,
    routes.WIFI_CONNECTION_GUIDE_STEPS,
    routes.DEVICE_REGISTRATION,
    routes.DEVICE_REGISTRATION_ERROR,
    routes.DEVICE_CONNECTION,
    routes.DEVICE_CONNECTION_ERROR,
    routes.DEVICE_CONNECTED,
];

const useHideNetworkNotifications = () => {
    const {pathname} = useLocation();
    const isDisabled = DISABLED_NETWORK_NOTIFICATIONS_PAGES.includes(pathname);

    useEffect(() => {
        dispatch(setIsNetworkNotificationsDisabled(isDisabled));
    }, [isDisabled]);
};

export default useHideNetworkNotifications;
